export default "__VITE_ASSET__uhEZvg_7__"